<div [matBadge]="showSelfPacedBadge ? 'S-P' : ''" matBadgePosition="before">
	@if (guid && !imageFailed()) {
		<div [style.width.px]="size" [style.height.px]="size" class="avatar-image-container" [nhaTest]="type + '-profile-avatar'">
			<img [src]="source" alt="avatar" (error)="onImageError()" />
		</div>
	} @else {
		<div class="avatar-icon-container" [style.width.px]="size" [style.height.px]="size" nhaTest="no-profile-avatar">
			<i class="material-icons" [style.font-size.px]="size"></i>
		</div>
	}
	@if (indicator) {
		<mat-icon class="indicator" [matTooltip]="indicatorMessage">{{ indicator }}</mat-icon>
	}
</div>
